module.exports = __webpack_public_path__ + "static/media/userIcon.ffaab1fc.svg";